module.exports = __webpack_public_path__ + "img/successStory6.73e8ac31.jpg";